import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Helmet} from 'react-helmet';
import { map, sumBy } from 'lodash';
import { Link } from 'react-router-dom';
import Spinner from '../../components/common/Spinner';
import ReactTable from 'react-table';
import selectTableHOC from "react-table/lib/hoc/selectTable";
import { importsActions } from '../../data/actions/imports';
import { auditReportsSettings } from '../../components/pages/imports/auditReports/Settings';
import CSV from '../../helpers/CSVExport';

var downloadSvg = require('!svg-inline-loader!../../../public/img/download.svg');

class AuditReports extends Component {
	constructor(props) {
		super(props);
		this.state = {
		}
		this.exportToCsv = this.exportToCsv.bind(this);
		this.deleteEntry = this.deleteEntry.bind(this);
		this.undoEntry = this.undoEntry.bind(this);
	}
	
	componentDidMount() {
		this.props.dispatch(importsActions.getAuditReports());
	}
	
	
	deleteEntry(id){
		this.props.dispatch(importsActions.deleteAuditLogEntry(id)).then(()=>this.props.dispatch(importsActions.getAuditReports()));
	}

	undoEntry(period, id){
		this.props.dispatch(importsActions.rejectSalesData(period, id)).then(()=>this.props.dispatch(importsActions.getAuditReports()));
	}

	exportToCsv(period){
		let {audit} = this.props.imports;
		const filename = CSV.CSVHeader('import_log', period);
		return CSV.CSVExport(audit, {filename}, 'import_log');
	}
	
	render() {
		const { auditLoading, audit, approveRejectLoading} = this.props.imports,
			rows = Array.isArray(audit) ? audit.length : null;
		
		return <div className="inner-page shared-pages">
			<div className="container">
				<h2>Import Log
				<a title="Export" onClick={()=>this.exportToCsv()} className="chart-icon download-link" dangerouslySetInnerHTML={{__html: downloadSvg}} />

				</h2>
				<div className="ibox">
					<ReactTable
						data={audit}
						loading={auditLoading}
						columns={auditReportsSettings.settingsForTable(this.deleteEntry, this.undoEntry)}
						pageSize={rows ? Math.min(rows, 10): 10}
						showPagination={rows > 10}
						className="simple-table share-table"
					/>
									</div>
			</div>
			<Helmet>
				<title>Import Log</title>
			</Helmet>

		</div>
	}
}

function mapStateToProps(state) {
	return {
		imports: state.imports
	} 
}

export default connect(mapStateToProps)(AuditReports)